import { render, staticRenderFns } from "./ModalChatUser.vue?vue&type=template&id=a31b0120&scoped=true"
import script from "./ModalChatUser.vue?vue&type=script&lang=js"
export * from "./ModalChatUser.vue?vue&type=script&lang=js"
import style0 from "./ModalChatUser.vue?vue&type=style&index=0&id=a31b0120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31b0120",
  null
  
)

export default component.exports